import { render } from "./MyTelegram.vue?vue&type=template&id=2fe828d0"
import script from "./MyTelegram.vue?vue&type=script&lang=js"
export * from "./MyTelegram.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__